import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IndicatorBoxModel } from '../../../../models/indicator-box.model';
import { IndicatorsSearchToolbarModel } from '../../../../models/indicators-search-toolbar-model.model';
import { LoyaltyChart } from '../../../../models/loyalty-chart-config.model';
import { QFilterModel } from '../../../../models/qfilter.model';
import { AnalyticsService } from '../../../../services/analytics/analytics.service';
import { CustomerCampaignService } from '../../../../services/customer/customer-campaign.service';
import { IndicatorsChartService, IndicatorsService } from '../../../../services/indicators/indicators.service';

@Component({
  selector: 'app-customer-value-detail',
  templateUrl: './customer-value-detail.component.html',
  styleUrls: ['./customer-value-detail.component.css']
})
export class CustomerValueDetailComponent implements OnInit {

  public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
  public indicators: IndicatorBoxModel[] = [];

  translations: any;

  valueSegmentDistributionChart: LoyaltyChart;
  spentAmountChart: LoyaltyChart;
  transactionsChart: LoyaltyChart;
  recencyChart: LoyaltyChart;
  spentVisitChart: LoyaltyChart;

  public data: QFilterModel;

  constructor(
    private indicatorService: IndicatorsService,
    private chartsService: IndicatorsChartService,
    private svcAnalytics: AnalyticsService,
    private srvCustomerCampaign: CustomerCampaignService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.translate.get([
      'customer_chart.valueSegmentDistribution',
      'customer_chart.spentAmount',
      'customer_chart.transactions',
      'customer_chart.recency',
      'customer_chart.spent_per_visit',
      'customer_chart.chart_serie_title',
      'customer_chart.chart_x_title',
      'customer_chart.chart_y_title',
      'common.previous_only',
      'common.actual'
    ]).subscribe((t) => {
      this.translations = {
        valueSegmentDistribution: t['customer_chart.valueSegmentDistribution'],
        spentAmount: t['customer_chart.spentAmount'],
        transactions: t['customer_chart.transactions'],
        recency : t['customer_chart.recency'],
        spent_per_visit: t['customer_chart.spent_per_visit'],
        chart_serie_title: t['customer_chart.chart_serie_title'],
        chart_x_title: t['customer_chart.chart_x_title'],
        chart_y_title: t['customer_chart.chart_y_title'],
        previous: t['common.previous_only'],
        actual: t['common.actual']
      };

      this.initCharts();
    });
  }

  initCharts() {
    this.valueSegmentDistributionChart = (new LoyaltyChart('bubble'));
    this.valueSegmentDistributionChart.options.plotOptions = { series: { dataLabels: { enabled: true, format: '{point.name}' } } };
    this.valueSegmentDistributionChart.options.yAxis.labels.format = '{value} ';
    this.valueSegmentDistributionChart.options.xAxis.title.text = this.translations.chart_x_title;
    this.valueSegmentDistributionChart.options.yAxis.title.text = this.translations.chart_y_title;
    this.valueSegmentDistributionChart.options.chart.height += 100;

    this.spentAmountChart = new LoyaltyChart('bar');
    this.spentAmountChart.options.xAxis.labels.format = '{value}';      // [P Non funziona!!! Lo mette sull'asse Y
    // this.spentAmountChart.options.xAxis.title.text = 'EUR';          // [P Non funziona!!! Lo mette sull'asse Y

    this.transactionsChart = new LoyaltyChart('bar');
    this.recencyChart = new LoyaltyChart('bar');

    this.spentVisitChart = new LoyaltyChart('bar');
    this.spentVisitChart.options.xAxis.labels.format = '{value}';       // [P Non funziona!!! Lo mette sull'asse Y
    // this.spentVisitChart.options.xAxis.title.text = 'EUR';           // [P Non funziona!!! Lo mette sull'asse Y
  }

  setChartInstance(chart: LoyaltyChart, chartInstance) {
    chart.instance = chartInstance;
  }

  searchValueTrend(data: QFilterModel) {
    this.data = data;

    this.chartsService.loadBubbleChart(this.valueSegmentDistributionChart, 'customers.Q062', data, this.indicatorService, this.translations);
    this.chartsService.loadChart(this.transactionsChart, 'customers.Q063A', data, this.indicatorService, this.translate, false, [LoyaltyChart.colors[15], LoyaltyChart.colors[21]], 'customer_chart');
    this.chartsService.loadChart(this.spentAmountChart, 'customers.Q063B', data, this.indicatorService, this.translate, false, [LoyaltyChart.colors[1], LoyaltyChart.colors[21]], 'customer_chart');
    this.chartsService.loadChart(this.recencyChart, 'customers.Q063C', data, this.indicatorService, this.translate, false, [LoyaltyChart.colors[2], LoyaltyChart.colors[21]], 'customer_chart');
    this.chartsService.loadChart(this.spentVisitChart, 'customers.Q063D', data, this.indicatorService, this.translate, false, [LoyaltyChart.colors[3], LoyaltyChart.colors[21]], 'customer_chart');
  }

  resetData() {
    this.data = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-value/customer-value-detail/customer-value-detail.component.ts